import { Trans } from "@lingui/react/macro";

import { currencyFormatter } from "@/common/services/formatter";
import { getSlashedQuarterName } from "@/common/utils/trading";
import { CropCategory } from "@/generated/digitalnisklady.cz/graphql";

type Price = {
  id: string;
  value: number;
  currency: string;
  quarter: {
    id: string;
    name: string;
  };
};

type Props = {
  className?: string;
  prices: Array<Price | null>;
  renderPrice?: (price: Props["prices"][number]) => React.ReactNode;
  category?: CropCategory;
};

const PriceList = ({
  renderPrice,
  prices,
  className = "",
  category,
}: Props) => {
  if (prices.length === 0) {
    return (
      <p className="text-center">
        <small>
          <Trans>Aktuální výkupní ceny nejsou k dispozici</Trans>
        </small>
      </p>
    );
  }
  return (
    <ul
      className={`border-can-silver-cloud bg-can-silver-gray text-can-midnight-steel @container grid grid-cols-4 rounded-2xl border px-2 text-xs ${className}`}
    >
      {prices.map((price, i) => (
        <li
          className="border-can-silver-cloud flex flex-col flex-wrap gap-y-2 border-r nth-4:border-none"
          key={i}
        >
          {renderPrice ? (
            renderPrice(price)
          ) : (
            <PriceItem category={category} price={price} />
          )}
        </li>
      ))}
    </ul>
  );
};

const PriceItem = ({
  price,
  category,
}: {
  price: Props["prices"][number];
  category?: CropCategory;
}) =>
  price ? (
    <>
      <b className="px-1 pt-2 @sm:px-2">
        {price.value
          ? currencyFormatter(price.currency, {
              maximumFractionDigits:
                category === CropCategory.Fuel
                  ? 2
                  : price.currency === "CZK"
                    ? 0
                    : 2,
            })
              .format(price.value)
              .replace(price.currency, "")
          : null}
      </b>
      <span className="px-2 pb-2">
        {getSlashedQuarterName(price.quarter.name)}
      </span>
    </>
  ) : null;

export { PriceItem, PriceList };
export type { Price };
